import React from 'react';
import PropTypes from 'prop-types';
import ToolTipIcon from '../../../components/ToolTipIcon/ToolTipIcon';

function AssetsActions(props) {
  const { onDownload, showFolderSelector, onDelete } = props;
  const {
    auth: {
      user: {
        permissions: { Writer },
      },
    },
  } = props;

  return (
    <div
      data-test="asset-actions"
      className="grid grid-cols-[repeat(5,_max-content)] md:grid-cols-[repeat(7,_max-content)] xl:grid-cols-[repeat(14,_max-content)] gap-2 mt-8"
    >
      {Writer && (
        <ToolTipIcon toolText="Delete Asset">
          <button
            type="button"
            onClick={onDelete}
            className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            <img
              src="/assets/images/icons/delete_button.svg"
              alt="Delete"
              className="w-[30px] h-[30px]"
              draggable={false}
            />
          </button>
        </ToolTipIcon>
      )}
      {Writer && (
        <ToolTipIcon toolText="Move Asset">
          <button
            type="button"
            onClick={showFolderSelector}
            className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            <img
              src="/assets/images/icons/paste_button.svg"
              alt="Delete"
              className="w-[30px] h-[30px]"
              draggable={false}
            />
          </button>
        </ToolTipIcon>
      )}
      {/* //TODO: replace with right icon */}
      <ToolTipIcon toolText="Download Asset">
        <button
          type="button"
          onClick={async () => {
            onDownload();
          }}
          className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
        >
          <img
            src="/assets/images/icons/copy_button.svg"
            alt="Copy"
            className="w-[30px] h-[30px]"
            draggable={false}
          />
        </button>
      </ToolTipIcon>
    </div>
  );
}

AssetsActions.propTypes = {
  auth: PropTypes.shape({
    user: PropTypes.shape({
      permissions: PropTypes.shape({
        Writer: PropTypes.bool,
      }),
    }),
  }).isRequired,
  showFolderSelector: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default AssetsActions;
